<!--
    描述：项目文件页面
    时间：2020-08-11
    Created by ws
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header">
			<div class="left-tabs">
				<span :class="{'is-active': activeName === 'file'}"
					  @click="changeTab('file')">分析文件</span>
				<span :class="{'is-active': activeName === 'report'}"
					  @click="changeTab('report')">分析报告</span>
			</div>

			<div class="btn-groups">
				<el-button size="small"
						   type="danger"
						   plain
						   v-if="roleBtns.includes('file-delete') || curSource === '1'"
						   @click="handleTool('delete')">批量删除</el-button>
				<el-button size="small"
						   type="primary"
						   @click="handleTool('report')"
						    v-if="roleBtns.includes('file-report')"
						   plain>生成报告</el-button>
				<el-button size="small"
						   type="primary"
						    v-if="roleBtns.includes('file-download') || curSource === '1'"
						   @click="handleTool('download')">批量下载</el-button>
			</div>
		</div>
		<!-- 下方内容 -->
		<div class="w-page-container">
			<w-split v-model="splitV"
					 class="h100">
				<!-- 左侧表格 -->
				<div class="w-table-layout w-table-page pdr10"
					 slot="left">
					<div class="w-table-content"
						 ref="tableContent">
						<el-table ref="xTable"
								  row-key="id"
								  :height="tableObj.tableH"
								  :data="tableObj.tableData"
								  highlight-current-row
								  v-loading="tableObj.loading"
								  stripe
								  @row-click="rowClick"
								  border>
							<el-table-column type="selection"
											 align="center"
											 width="50">
							</el-table-column>
							<el-table-column type="index"
											 label="序号"
											 align="center"
											 width="60">
							</el-table-column>
							<el-table-column label="文件名称"
											 prop="fileSaveName"
											 show-overflow-tooltip
											 align="center"
											 min-width="150">
							</el-table-column>
							<el-table-column label="文件格式"
											 prop="fileSuffix"
											 show-overflow-tooltip
											 align="center"
											 sortable
											 width="110">
							</el-table-column>
							<el-table-column label="创建人"
											 prop="createUserName"
											 show-overflow-tooltip
											 sortable
											 align="center"
											 width="120">
							</el-table-column>
							<el-table-column label="创建时间"
											 prop="createDateName"
											 sortable
											 show-overflow-tooltip
											 align="center"
											 width="120">
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination @size-change="handleSizeChange"
									   @current-change="handleCurrentChange"
									   :current-page="tableObj.currentPage"
									   :page-sizes="tableObj.pageList"
									   :page-size="tableObj.pageSize"
									   :total="tableObj.total"
									   layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</div>
				</div>
				<!-- 右侧预览 -->
				<div class="preview-container h100"
					 slot="right">
					<h3 class="preview-title"><span>导出人：{{ previewObj.userName }}</span> <span
							  class="ml10">导出时间：{{ previewObj.dateTime }}</span></h3>
					<div class="preview-box"
						 v-if="previewObj.previewUrl !== ''">
						<iframe :src="previewObj.previewUrl"
								frameborder="0"
								id="iframe"
								width="100%"
								height="100%">
						</iframe>
					</div>
					<div class="preview-box"
						 v-else><span>预览区域</span></div>
				</div>
			</w-split>
		</div>

		<!-- 生成报告弹窗 -->
		<el-dialog :visible="dialogObj.visible"
				   :title="dialogObj.title"
				   :width="dialogObj.width"
				   close-on-click-modal
				   @close="handleClosed">
			<el-form ref="reportForm"
					 :model="reportParams"
					 :rules="reportRules"
					 label-width="110px">
				<el-form-item label="导出文件格式"
							  class="mb0">
					<el-radio-group v-model="reportParams.reportType">
						<el-radio :label="1">DOC</el-radio>
						<el-radio :label="2">PDF</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="报告名称"
							  prop="fileSaveName"
							  :show-message="false">
					<el-input placeholder="请输入报告名称"
							  v-model="reportParams.fileSaveName"></el-input>
				</el-form-item>
				<el-form-item label="报告备注">
					<el-input type="textarea"
							  placeholder="请输入内容"
							  v-model="reportParams.tag"
							  maxlength="200"
							  show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<el-table ref="dragTable"
					  height="370"
					  row-key="id"
					  :data="reportParams.fileList"
					  highlight-current-row
					  stripe
					  border>
				<el-table-column type="index"
								 label="序号"
								 align="center"
								 width="55">
				</el-table-column>
				<el-table-column type="action"
								 label="操作"
								 align="center"
								 width="60">
					<template slot-scope="scope">
						<el-button type="text"
								   size="mini"
								   icon="el-icon-delete"
								   @click="handleRemove(scope.$index)"></el-button>
					</template>
				</el-table-column>
				<el-table-column label="文件名称"
								 prop="fileSaveName"
								 show-overflow-tooltip
								 align="center"
								 min-width="150">
				</el-table-column>
				<el-table-column label="文件格式"
								 prop="fileSuffix"
								 show-overflow-tooltip
								 align="center"
								 width="90">
				</el-table-column>
				<el-table-column label="创建人"
								 prop="createUserName"
								 show-overflow-tooltip
								 align="center"
								 width="120">
				</el-table-column>
				<el-table-column label="创建时间"
								 prop="createDateName"
								 show-overflow-tooltip
								 align="center"
								 width="120">
				</el-table-column>
			</el-table>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="dialogObj.btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Sortable from 'sortablejs'
import { getFileList, deleteFile, saveReport } from '@/api/modules/file_list'
import { previewFile } from '@/api/modules/sys'
import { exportExcel } from '@/utils/tools'
import service from '@/api/request'
import { mapState } from 'vuex'

export default {
	data() {
		return {
			activeName: 'file',
			splitV: 0.4,
			tableObj: {
				loading: false,
				tableData: [],
				tableH: 0,
				current: 1,
				pageSize: 10,
				pageList: [10, 20, 50, 100],
				total: 0,
				fileList: [] // 所选择的文件数据
			},
			// 弹窗对象
			dialogObj: {
				visible: false,
				width: '600px',
				type: 'report',
				title: '生成报告',
				btnLoading: false
			},
			// 生成报告弹窗参数
			reportParams: {
				fileSaveName: '', // 报告名称
				tag: '', // 报告备注
				reportType: 1, // 导出类型 doc 、 pdf
				ids: [],
				fileList: [] // 要生成的 文件列表
			},
			reportRules: {
				fileSaveName: [{ required: true }]
			},
			// 表格拖拽
			sortable: null,
			oldList: [],
			newList: [],
			// 预览对象
			previewObj: {
				previewUrl: '', // 预览文件地址
				userName: '', // 导出人
				dateTime: '' // 导出时间
			}
		}
	},
	created() {
		// 初始获取数据
		this.getList()

		this.$nextTick(() => {
			this.tableObj.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 获取文件列表
		getList() {
			this.tableObj.loading = true
			let _type = this.activeName === 'file' ? 1 : 2
			let params = {
				type: _type, // ---文件类型(1:分析文件；2：分析报告)
				fileOrignName: '', //  文件名称搜索用
				current: this.tableObj.current,
				size: this.tableObj.pageSize,
				projectId: this.curProjectId // 项目id
			}
			getFileList(params)
				.then(res => {
					this.tableObj.loading = false
					this.tableObj.total = parseInt(res.data.total)
					this.tableObj.tableData = res.data.records

					this.oldList = res.data.records.map(x => x.id)
					this.newList = this.oldList.slice()
				})
				.catch(err => {
					this.tableObj.loading = false
				})
		},

		changeFrameHeight() {
			console.log(1)
			return
			var ifm = document.getElementById('iframe')
			ifm.setAttribute('height', 'auto')
			ifm.height = document.documentElement.clientHeight
			ifm.width = document.documentElement.clientWidth
			console.log('高度', document.documentElement.clientHeight)
		},

		// 切换 tab 页显示
		changeTab(name) {
			this.activeName = name
			this.tableObj.loading = true
			this.previewObj.previewUrl = ''
			this.previewObj.userName = ''
			this.previewObj.dateTime = ''
			setTimeout(() => {
				this.getList()
			}, 800)
		},

		// 切换显示条数
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.getList()
		},

		// 切换当前页码
		handleCurrentChange(page) {
			this.tableObj.current = page
			this.getList()
		},

		// 左侧行单击事件
		rowClick(row) {
			if (row && row.id) {
				this.previewObj.userName = row.createUserName
				this.previewObj.dateTime = row.createDate

				service({
					method: 'post',
					url: 'sysFile/previewFile',
					data: { id: row.id, fileSuffix: row.fileSuffix },
					responseType: 'blob',
					timeout: 100000
				})
					.then(res => {
						let blob = new Blob([res.data], { type: res.data.type })
						let _url = URL.createObjectURL(blob)
						this.previewObj.previewUrl = _url

						// var ifm = document.getElementById('iframe')
						// ifm.height = 'auto'
						// ifm.height =
						// 	ifm.contentWindow.document.body.scrollHeight
						// ifm.width = document.documentElement.clientWidth
						// console.log(ifm.contentWindow.document.body)

						// if (ifm) {
						// 	var iframeWin =
						// 		ifm.contentWindow ||
						// 		ifm.contentDocument.parentWindow
						// 	if (iframeWin.document.body) {
						// 		ifm.height =
						// 			ifm.document.documentElement.scrollHeight ||
						// 			ifm.document.body.scrollHeight
						// 	}
						// }
					})
					.catch(error => {
						this.previewObj.previewUrl = ''
						// console.log(error)
					})
			}
		},

		// 操作按钮
		handleTool(type) {
			let _selection = this.$refs.xTable.selection

			// 选择数据
			if (_selection.length === 0) {
				this.$message.warning('请先选择要操作的数据！')
				return
			}

			this.reportParams.fileList = JSON.parse(JSON.stringify(_selection))
			let id_arr = this.reportParams.fileList.map(x => x.id)
			switch (type) {
				case 'delete':
					this.$confirm('是否确认删除选中的文件?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							deleteFile({
								id: id_arr
							}).then(res => {
								this.$message({
									type: 'success',
									message: '删除成功!'
								})

								// 重新请求数据
								this.getList()
							})
						})
						.catch(() => {})
					break
				case 'report':
					this.dialogObj.visible = true

					// 表格拖拽
					setTimeout(() => {
						this.setSort()
					}, 500)
					break
				case 'download':
					// 单个下载
					if (id_arr.length === 1) {
						exportExcel(
							'sysFile/downloadFile',
							{ id: id_arr[0] },
							_selection[0].fileSaveName
						)
					} else {
						// 多个压缩包
						let url = process.env.VUE_APP_BASE_URL
						let str = id_arr.join(',')
						window.open(
							`${url}/sysFile/batchDownloadFiles?ids=${str}`,
							'_blank'
						)
					}
					break
				default:
			}
		},

		// 生成报告页面 移除
		handleRemove(index) {
			this.reportParams.fileList.splice(index, 1)
		},

		// 弹窗确认
		doSave() {
			this.$refs.reportForm.validate(valid => {
				if (valid) {
					this.reportParams.projectId = this.curProjectId
					this.reportParams.ids = this.reportParams.fileList.map(
						x => x.id
					)
					saveReport(this.reportParams).then(res => {
						console.log(res)
					})
				} else {
					this.$message.error('请输入报告名称')
				}
			})
		},

		// 关闭弹窗
		handleClosed() {
			this.dialogObj.visible = false
		},

		// 设置表格拖拽
		setSort() {
			const el = this.$refs.dragTable.$el.querySelectorAll(
				'.el-table__body-wrapper > table > tbody'
			)[0]
			this.sortable = Sortable.create(el, {
				ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
				setData: function(dataTransfer) {
					dataTransfer.setData('Text', '')
				},
				onEnd: evt => {
					const targetRow = this.reportParams.fileList.splice(
						evt.oldIndex,
						1
					)[0]
					this.reportParams.fileList.splice(
						evt.newIndex,
						0,
						targetRow
					)
					const tempIndex = this.newList.splice(evt.oldIndex, 1)[0]
					this.newList.splice(evt.newIndex, 0, tempIndex)
				}
			})
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},

		...mapState('menu', {
			roleBtns: state => state.roleBtns
		}),

		// 项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
	}
}
</script>

<style scoped lang="less">
.preview-container {
	border: 1px solid #e4e7ed;
	margin-left: 5px;

	.preview-title {
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		font-weight: normal;
		padding: 0 10px;
	}

	.preview-box {
		height: calc(~'100% - 30px');
		font-size: 30px;
		// display: flex;
		align-items: center;
		justify-content: center;
		border: 1px dashed #ccc;
		margin: 0 5px;
		// overflow-y: auto;
	}
}

/deep/ .scaleBox {
	body {
		overflow: hidden;
	}
	table {
		transform: scale(0.8);
	}
}

.mb0 {
	margin-bottom: 0 !important;
}

.mb0 {
	margin-bottom: 0 !important;
}

/deep/ .el-form-item {
	margin-bottom: 10px;
}
</style>
